type Props = {
  userInfo: any
};



const User = ({ userInfo }: Props) => {

  const prn = {
    ko: [
      {
        title: '내 정보',
        url: '/account'
      },
      {
        title: '로그아웃',
        url: '/logout'
      },
      {
        title: '로그인',
        url: '/login'
      },
      {
        title: '회원가입',
        url: '/join'
      }
    ],
    en: [
      {
        title: 'My page',
        url: '/account'
      },
      {
        title: 'Sign Out',
        url: '/logout'
      },
      {
        title: 'Sign In',
        url: '/login'
      },
      {
        title: 'Join',
        url: '/join'
      }
    ]
  }

  const prnList = window.__LANG__ === 'en' ? prn.en : prn.ko;
  const filteredPrnList = userInfo.isLoggedIn ? prnList.splice(0, 2) : prnList.splice(2, 2);  

  return (
    <div className="user">
      {
        filteredPrnList.map((item, index) => (
          <a key={index} href={item.url}>{item.title}</a>
        ))
      }
    </div>
  );
};

export default User;
